module.exports = __webpack_public_path__ + "static/media/app-banner-mobile.d31483fd.jpg";